import * as React from 'react';
import clsx from 'classnames';

function SvgLocked({className, ...props}) {
    return (
        <svg width={12} height={15} fill="none" className={clsx('text-font-tertiary', className)} {...props}>
            <path
                d="M10 13.344V6.656H2v6.688h8zM3.937 4v1.344h4.126V4a1.91 1.91 0 00-.626-1.438A1.91 1.91 0 006 1.938c-.563 0-1.052.208-1.469.625A1.958 1.958 0 003.938 4zM10 5.344c.354 0 .667.135.938.406.27.25.406.552.406.906v6.688c0 .354-.136.666-.406.937a1.34 1.34 0 01-.938.375H2c-.354 0-.667-.125-.938-.375-.27-.27-.406-.583-.406-.937V6.656c0-.354.136-.656.406-.906.271-.27.584-.406.938-.406h.656V4c0-.917.323-1.698.969-2.344.667-.666 1.458-1 2.375-1s1.698.334 2.344 1c.666.646 1 1.427 1 2.344v1.344H10zm-3.063 5.593c-.27.271-.583.407-.937.407-.354 0-.667-.136-.938-.406-.27-.271-.406-.584-.406-.938s.136-.667.407-.938c.27-.27.583-.406.937-.406.354 0 .667.136.938.406.27.271.406.584.406.938s-.136.667-.407.938z"
                fill="currentColor"
            />
        </svg>
    );
}

export default SvgLocked;
